<div class="otp-container">
  <div class="otp-card">
    <!-- Icon badge -->
    <div class="otp-icon-wrap">
      <i class="pi pi-envelope"></i>
    </div>

    <!-- Header -->
    <div class="otp-header">
      <h2 class="otp-title">Email Verification</h2>
      <p class="otp-subtitle">
        Enter the 6-digit code sent to
        <strong>{{ email }}</strong>
      </p>
    </div>

    <!-- Error banner -->
    @if (errorMessage) {
      <div class="otp-error">
        <i class="pi pi-exclamation-circle"></i>
        {{ errorMessage }}
      </div>
    }

    <!-- OTP field -->
    <div class="otp-field">
      <label class="otp-label">Verification Code <span class="otp-required">*</span></label>
      <input
        class="otp-input"
        type="text"
        [(ngModel)]="otp"
        name="otp"
        placeholder="······"
        maxlength="6"
        autocomplete="one-time-code"
      />
    </div>

    <!-- Verify button -->
    <button class="otp-btn" (click)="verifyOtp()" [disabled]="loading || !otp || otp.length < 4">
      @if (loading) {
        <i class="pi pi-spin pi-spinner"></i>
      }
      <span>{{ loading ? 'Verifying…' : 'Verify Email' }}</span>
    </button>

    <!-- Footer -->
    <p class="otp-footer flex align-items-center justify-content-center gap-1">
      <span>Didn't receive it?</span>
      <button class="otp-link" type="button" (click)="resendOtp()">Resend code</button>
    </p>
  </div>
</div>
